module.exports = __webpack_public_path__ + "static/media/igLogo.219fcc50.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/igLogo.png
// module id = 684
// module chunks = 11